import { useTranslation } from 'react-i18next'
import { Button } from '@bosch/react-frok'

type Props = {
    isRecording: boolean
    onClick: () => void
    disabled?: boolean
    className?: string
}

// Starts and stops the recording of an InputAudio (see useAudioRecording)
const MicrophoneButton = ({ isRecording, onClick, disabled, className }: Props) => {
    const { t } = useTranslation()

    return (
        <Button
            className={className}
            mode={isRecording ? 'primary' : 'integrated'}
            icon={{
                iconName: isRecording ? 'checkmark' : 'microphone-classic',
                title: t(isRecording ? 'chat:audio:stop' : 'chat:audio:record'),
            }}
            onClick={onClick}
            disabled={disabled}
        />
    )
}

export default MicrophoneButton
